// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.SelectedItemsBar-transition-wrapper {
  position: fixed;
  bottom: 0;
  background-color: var(--base_color2);
  z-index: 10;
  min-width: 100%;
  height: auto;
  right: 0;
  padding: 10px 0 20px 80px;
  border-top: 1px solid var(--gray_light2);
}
.SelectedItemsBar-transition-wrapper.slide-from-bottom-enter {
  height: 0;
  bottom: -72px;
}
.SelectedItemsBar-transition-wrapper.slide-from-bottom-enter.slide-from-bottom-enter-active {
  bottom: 0;
  height: auto;
  transition: all 200ms ease-in-out;
}
.SelectedItemsBar-transition-wrapper.slide-from-bottom-leave {
  bottom: 0;
  right: 0;
  height: auto;
}
.SelectedItemsBar-transition-wrapper.slide-from-bottom-leave.slide-from-bottom-leave-active {
  bottom: -72px;
  max-width: 0;
  transition: all 200ms ease-in-out;
}
.SelectedItemsBar-transition-wrapper-content {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1366px;
  margin: 0 auto;
  gap: 5px;
  padding-right: 65px;
}
.SelectedItemsBar-transition-wrapper-content-actions {
  min-width: 305px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 15px;
}
.SelectedItemsBar-transition-wrapper-content-actions [data-testid=block-components-non-viewer] {
  display: flex;
  align-items: center;
}
.SelectedItemsBar-transition-wrapper-content-actions [data-testid=block-components-non-viewer]:last-child {
  font-size: 13px;
}
.SelectedItemsBar-transition-wrapper-content-actions button {
  font-weight: 700;
  font-size: 0.8125rem;
}
.SelectedItemsBar-transition-wrapper-content-actions div {
  display: inline-block;
}
.SelectedItemsBar-transition-wrapper-content-actions [class^=dist_tooltipped] {
  display: inline-block;
}
.SelectedItemsBar-transition-wrapper-content-items {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  transition-duration: 0.2s;
  justify-content: flex-end;
  align-items: center;
}
.SelectedItemsBar-transition-wrapper-content-items .carousel {
  width: 100%;
  height: 56px;
}
.SelectedItemsBar-transition-wrapper-content-items [class^=dist_Carousel_button-wrapper] {
  height: 56px;
}
.SelectedItemsBar-transition-wrapper-content-items p {
  align-self: flex-start;
  font-size: 12px;
  margin-bottom: 5px;
  color: var(--gray_dark2);
  font-weight: 600;
}
.SelectedItemsBar-transition-wrapper-content-items ul {
  display: flex;
  flex-grow: 1;
  width: 100%;
  margin: 0;
  padding: 0;
  gap: 7px;
}
.SelectedItemsBar-transition .SelectedItems-compare-button svg {
  fill: none !important;
}
.SelectedItemsBar-transition .SelectedItems-compare-button:hover svg rect {
  fill: var(--color_primary_500) !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button svg {
  fill: none !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button svg path:nth-child(2) {
  stroke: var(--color_primary_500) !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button:hover svg {
  fill: var(--color_primary_500) !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button:hover svg path:nth-child(2) {
  stroke: var(--base_color2) !important;
}
.SelectedItemsBar-transition .SelectedItems-add-button svg {
  fill: none !important;
}
.SelectedItemsBar-transition .SelectedItems-add-button:hover svg {
  fill: var(--color_primary_500) !important;
}
.SelectedItemsBar-transition .SelectedItems-compare-button svg,
.SelectedItemsBar-transition .SelectedItems-add-button svg {
  fill: var(--color_primary_500) !important;
}
.SelectedItemsBar-transition .SelectedItems-compare-button:disabled, .SelectedItemsBar-transition .SelectedItems-compare-button:disabled:hover,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled:hover {
  color: var(--color_neutral_800) !important;
}
.SelectedItemsBar-transition .SelectedItems-compare-button:disabled svg, .SelectedItemsBar-transition .SelectedItems-compare-button:disabled:hover svg,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled svg,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled:hover svg {
  fill: var(--color_neutral_800) !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button:disabled, .SelectedItemsBar-transition .SelectedItems-remove-button:disabled:hover,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled:hover {
  color: var(--color_neutral_800) !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button:disabled svg, .SelectedItemsBar-transition .SelectedItems-remove-button:disabled:hover svg,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled svg,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled:hover svg {
  fill: none !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button:disabled svg path, .SelectedItemsBar-transition .SelectedItems-remove-button:disabled:hover svg path,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled svg path,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled:hover svg path {
  stroke: var(--color_neutral_800) !important;
}
.SelectedItemsBar-transition .SelectedItems-remove-button:disabled svg rect, .SelectedItemsBar-transition .SelectedItems-remove-button:disabled:hover svg rect,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled svg rect,
.SelectedItemsBar-transition .SelectedItems-add-button:disabled:hover svg rect {
  stroke: var(--color_neutral_800) !important;
  fill: var(--color_neutral_800) !important;
}
.SelectedItemsBar-transition .manageItemsButton {
  color: var(--color_neutral_800) !important;
  font-weight: 400;
}
.SelectedItemsBar-transition .manageItemsButton svg {
  fill: var(--color_neutral_800) !important;
}
.SelectedItemsBar-transition .manageItemsButton:disabled, .SelectedItemsBar-transition .manageItemsButton:disabled:hover {
  color: var(--color_neutral_500) !important;
  background-color: transparent !important;
}
.SelectedItemsBar-transition .manageItemsButton:disabled svg, .SelectedItemsBar-transition .manageItemsButton:disabled:hover svg {
  fill: var(--color_neutral_500) !important;
}
.SelectedItemsBar-transition .manageItemsButton:hover {
  color: var(--color_primary_500) !important;
  background-color: var(--color_primary_100) !important;
}
.SelectedItemsBar-transition .manageItemsButton:hover svg {
  fill: var(--color_primary_500) !important;
}
.SelectedItemsBar-transition .cancelButton {
  margin-right: 16px;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/SelectedItemsBar/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAZE;EACE,eAAA;EACA,SAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,yBAAA;EACA,wCAAA;AAcJ;AAZI;EACE,SAAA;EACA,aAAA;AAcN;AAZM;EACE,SAAA;EACA,YAAA;EACA,iCAAA;AAcR;AAVI;EACE,SAAA;EACA,QAAA;EACA,YAAA;AAYN;AAVM;EACE,aAAA;EACA,YAAA;EACA,iCAAA;AAYR;AARI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,QAAA;EACA,mBAAA;AAUN;AARM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAUR;AARQ;EACE,aAAA;EACA,mBAAA;AAUV;AARU;EACE,eAAA;AAUZ;AANQ;EACE,gBAAA;EACA,oBAAA;AAQV;AALQ;EACE,qBAAA;AAOV;AAJQ;EACE,qBAAA;AAMV;AAFM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,mBAAA;AAIR;AAFQ;EACE,WAAA;EACA,YAAA;AAIV;AADQ;EACE,YAAA;AAGV;AAAQ;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,gBAAA;AAEV;AACQ;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;AACV;AAMI;EACE,qBAAA;AAJN;AAOI;EACE,yCAAA;AALN;AAUI;EACE,qBAAA;AARN;AAUM;EACE,2CAAA;AARR;AAYI;EACE,yCAAA;AAVN;AAYM;EACE,qCAAA;AAVR;AAgBI;EACE,qBAAA;AAdN;AAiBI;EACE,yCAAA;AAfN;AAqBI;;EACE,yCAAA;AAlBN;AAqBI;;;EAEE,0CAAA;AAlBN;AAoBM;;;EACE,yCAAA;AAhBR;AAwBI;;;EAEE,0CAAA;AArBN;AAuBM;;;EACE,qBAAA;AAnBR;AAqBQ;;;EACE,2CAAA;AAjBV;AAoBQ;;;EACE,2CAAA;EACA,yCAAA;AAhBV;AAsBE;EACE,0CAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,yCAAA;AApBN;AAuBI;EAEE,0CAAA;EACA,wCAAA;AAtBN;AAwBM;EACE,yCAAA;AAtBR;AA2BE;EACE,0CAAA;EACA,qDAAA;AAzBJ;AA2BI;EACE,yCAAA;AAzBN;AA6BE;EACE,kBAAA;AA3BJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.SelectedItemsBar-transition {\n  &-wrapper {\n    position: fixed;\n    bottom: 0;\n    background-color: var(--base_color2);\n    z-index: 10;\n    min-width: 100%;\n    height: auto;\n    right: 0;\n    padding: 10px 0 20px 80px;\n    border-top: 1px solid var(--gray_light2);\n\n    &.slide-from-bottom-enter {\n      height: 0;\n      bottom: -72px;\n\n      &.slide-from-bottom-enter-active {\n        bottom: 0;\n        height: auto;\n        transition: all 200ms ease-in-out;\n      }\n    }\n\n    &.slide-from-bottom-leave {\n      bottom: 0;\n      right: 0;\n      height: auto;\n\n      &.slide-from-bottom-leave-active {\n        bottom: -72px;\n        max-width: 0;\n        transition: all 200ms ease-in-out;\n      }\n    }\n\n    &-content {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      max-width: 1366px;\n      margin: 0 auto;\n      gap: 5px;\n      padding-right: 65px;\n\n      &-actions {\n        min-width: 305px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        margin-top: 15px;\n\n        [data-testid='block-components-non-viewer'] {\n          display: flex;\n          align-items: center;\n\n          &:last-child {\n            font-size: 13px;\n          }\n        }\n\n        button {\n          font-weight: 700;\n          font-size: 0.8125rem;\n        }\n\n        div {\n          display: inline-block;\n        }\n\n        [class^='dist_tooltipped'] {\n          display: inline-block;\n        }\n      }\n\n      &-items {\n        display: flex;\n        flex-direction: column;\n        flex-grow: 1;\n        transition-duration: 0.2s;\n        justify-content: flex-end;\n        align-items: center;\n\n        .carousel {\n          width: 100%;\n          height: 56px;\n        }\n\n        [class^='dist_Carousel_button-wrapper'] {\n          height: 56px;\n        }\n\n        p {\n          align-self: flex-start;\n          font-size: 12px;\n          margin-bottom: 5px;\n          color: var(--gray_dark2);\n          font-weight: 600;\n        }\n\n        ul {\n          display: flex;\n          flex-grow: 1;\n          width: 100%;\n          margin: 0;\n          padding: 0;\n          gap: 7px;\n        }\n      }\n    }\n  }\n\n  .SelectedItems-compare-button {\n    svg {\n      fill: none !important;\n    }\n\n    &:hover svg rect {\n      fill: var(--color_primary_500) !important;\n    }\n  }\n\n  .SelectedItems-remove-button {\n    svg {\n      fill: none !important;\n\n      path:nth-child(2) {\n        stroke: var(--color_primary_500) !important;\n      }\n    }\n\n    &:hover svg {\n      fill: var(--color_primary_500) !important;\n\n      path:nth-child(2) {\n        stroke: var(--base_color2) !important;\n      }\n    }\n  }\n\n  .SelectedItems-add-button {\n    svg {\n      fill: none !important;\n    }\n\n    &:hover svg {\n      fill: var(--color_primary_500) !important;\n    }\n  }\n\n  .SelectedItems-compare-button,\n  .SelectedItems-add-button {\n    svg {\n      fill: var(--color_primary_500) !important;\n    }\n\n    &:disabled,\n    &:disabled:hover {\n      color: var(--color_neutral_800) !important;\n\n      svg {\n        fill: var(--color_neutral_800) !important;\n      }\n    }\n  }\n\n  .SelectedItems-remove-button,\n  .SelectedItems-add-button {\n\n    &:disabled,\n    &:disabled:hover {\n      color: var(--color_neutral_800) !important;\n\n      svg {\n        fill: none !important;\n\n        path {\n          stroke: var(--color_neutral_800) !important;\n        }\n\n        rect {\n          stroke: var(--color_neutral_800) !important;\n          fill: var(--color_neutral_800) !important;\n        }\n      }\n    }\n  }\n\n  .manageItemsButton {\n    color: var(--color_neutral_800) !important;\n    font-weight: 400;\n\n    svg {\n      fill: var(--color_neutral_800) !important;\n    }\n\n    &:disabled,\n    &:disabled:hover {\n      color: var(--color_neutral_500) !important;\n      background-color: transparent !important;\n\n      svg {\n        fill: var(--color_neutral_500) !important;\n      }\n    }\n  }\n\n  .manageItemsButton:hover {\n    color: var(--color_primary_500) !important;\n    background-color: var(--color_primary_100) !important;\n\n    svg {\n      fill: var(--color_primary_500) !important;\n    }\n  }\n\n  .cancelButton {\n    margin-right: 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
